import { IntegrationType } from "@/types/app/ooc/integration.type";

export default class Integration {
  public static MODULE_NAME = "ooc/integration";
  businessCount: number = 0;
  countries: string = "";
  id: string = "";
  integrationName: string = "";

  constructor(data: IntegrationType = null) {
    if (data) {
      this.businessCount = data.business_count || 0;
      this.countries = data.countries || "";
      this.id = data.id || "";
      this.integrationName = data.integration_name || "";
    }
  }
}
